const Messaging = window.tnew.ui.messaging;


const Key = {
  Page: 'opg--page',
  AmountEntry: 'opg--amount',
};

const getContainer = () => document.querySelector('#tn-opg-form-amount-error-message-container');

const addPageError = msg => Messaging.addError(msg, true, Key.Page);

const addAmountEntryError = msg => Messaging.addError(msg, true, Key.AmountEntry, getContainer());
const clearAmountEntryErrors = () => Messaging.clearErrors(Key.AmountEntry);

export default {
  addPageError,
  addAmountEntryError,
  clearAmountEntryErrors,
  clearErrors: () => Messaging.clearErrors(),
};



// WEBPACK FOOTER //
// ./src/onePageGiving/OnePageGivingMessaging.js